module.exports = __webpack_public_path__ + "img/DSC_0057.0be39076.jpg";